export const DynamicFormSystemRole = {
  PARTNER_NAME: 'PARTNER_NAME',
  CONTACT_NAME: 'CONTACT_NAME',
  CONTACT_EMAIL: 'CONTACT_EMAIL',
  CONTACT_PHONE: 'CONTACT_PHONE',
};

export const ProjectlessWorksheetFields = [
  { systemRole: DynamicFormSystemRole.PARTNER_NAME, name: 'Partner neve' },
  { systemRole: DynamicFormSystemRole.CONTACT_NAME, name: 'Kapcsolattartó neve' },
  { systemRole: DynamicFormSystemRole.CONTACT_EMAIL, name: 'E-mail cím' },
  { systemRole: DynamicFormSystemRole.CONTACT_PHONE, name: 'Telefonszám' },
];
